enum Actions {
  QuerySearch = 'search/QUERY_SEARCH',
  ClearSearch = 'search/CLEAR_SEARCH',
  UpdateOrderFilter = 'search/UPDATE_ORDER_FILTER',
}

export const SearchActionTypes = {
  ...Actions,
};
